<template>
  <div class="container">
    <img class="sent-img" src="images/email-sent.png" alt="" />
    <div class="title">
      {{ $t("sendEmail.almost") }}
    </div>
    <div class="desc">
      {{ $t(descriptionTextKey) }}
    </div>
    <img
      class="mt-4"
      :src="stepImage1"
      alt=""
    />
    <img
      class="mt-4"
      :src="stepImage2"
      alt=""
    />
    <div class="button" @click="finish">{{ $t("General.Done") }}</div>
    <div class="help" @click="askHelp">
      {{ $t("sendEmail.contact_us") }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isIos: false,
      isRepair: false,
      isCheck: false
    };
  },
  computed: {
    descriptionTextKey() {
      if (this.isCheck) {
        return "sendEmail.check_launch_tip";
      }
      return this.isRepair
        ? "sendEmail.repair_launch_tip"
        : "sendEmail.launch_tip";
    },
    stepImage1() {
      if (this.isCheck) {
        return "images/check-sent-1.png";
      }
      return this.isRepair
        ? "images/screen-repair.png"
        : "images/screen-unlock.png";
    },
    stepImage2() {
      if (this.isCheck) {
        return "images/check-sent-2.png";
      }
      return this.isRepair ? "images/repair-mainpage.png" : "images/login.png";
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.isIos = urlParams.get("os_name").toLowerCase() === "ios";
    this.isRepair = urlParams.get("feature") === "repair";
    this.isCheck = urlParams.get("feature") === "check";
  },
  methods: {
    finish() {
      if (this.isIos && window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.drfoneApp.postMessage({
          msgType: "SendFinish",
          msgData: this.isRepair
            ? "repair-website"
            : this.isCheck
            ? "check-website"
            : "website"
        });
      } else if (window.android) {
        window.android.close(
          this.isRepair
            ? "repair-website"
            : this.isCheck
            ? "check-website"
            : "website"
        );
      }
    },
    askHelp(event) {
      if (this.isIos && window.webkit && window.webkit.messageHandlers) {
        event.preventDefault();
        window.webkit.messageHandlers.drfoneApp.postMessage({
          msgType: "OpenUrl",
          msgData: "https://drfone.wondershare.com/support/"
        });
      } else if (window.android) {
        window.android.openUrl("https://drfone.wondershare.com/support/");
      } else {
        window.location.href = "https://drfone.wondershare.com/support/";
      }
    }
  }
};
</script>

<style>
#app {
  background-color: #f9fbfe;
}
</style>

<style scoped>
.mt-4 {
  margin-top: 16px !important;
}

.container {
  max-width: 375px;
  padding: 0 16px 12px;
  /* font-family: SF Pro Text; */
}

.sent-img {
  width: 100%;
  max-width: 342px;
  padding: 0 49px;
}

.title {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  text-align: center;
  color: #000000f2;
}

.desc {
  margin-top: 26px;
  font-size: 14px;
  line-height: 24px;
  color: #12121d;
}

.button {
  margin-top: 6px;
  height: 48px;
  padding: 14px 8px;
  border-radius: 100px;
  background: #0084ff;

  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.23999999463558197px;
  text-align: center;
  color: #fff;
}

.button:active {
  background: #0071f5;
}

.help {
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: center;
  color: #0095ff;
  text-decoration: underline;
  margin-top: 16px;
}
</style>
